import constants from '../../constants';

const getTextColorsUsedByBlock = (blockId, customStylesheet) => {
  const { cssRules } = customStylesheet;
  let list = [];

  Object.values(cssRules).forEach((rule) => {
    const {
      selectorText,
      style: { cssText },
    } = rule;

    if (selectorText.startsWith(`#${blockId}`)) {
      const subList = cssText.split(';').reduce((map, propertyRule) => {
        const isTextColor = propertyRule
          .trim()
          .startsWith(`--${constants.TEXT_COLOR_CSS_VARIABLE}`);

        if (!isTextColor) return map;

        const [prop] = propertyRule.split(':');
        return [...map, prop.trim()];
      }, []);

      list = [...list, ...subList];
    }
  });

  return list;
};

export default getTextColorsUsedByBlock;
